module.exports = __webpack_public_path__ + "static/media/allisonrietta-IG.591bd364.PNG";